module.exports = __webpack_public_path__ + "images/category_lp/pc/lppc-HowTo_Bar_bg_9aee1adbe75fa8d6d9b0c247a03b0fcf.png";